import { mapGetters } from 'vuex'
import Recommendation from '@/components/molecules/Recommendation'
import { EventBus } from '@/modules/plugins/modules/event'

export default {
    components: {
        Recommendation,
    },

    props: {
        card: Boolean,
    },

    computed: {
        ...mapGetters({
            enabled: 'recommender/enabled',
            recommender: 'recommender/recommender',
            loading: 'recommender/loading',
            x: 'recommender/recommendations',
        }),
        recommendations() {
            if (!this.$restaurant?.model?.categories) return []
            return this.$store.getters['recommender/recommendations']?.map((recommendation) => {
                return {
                    ...(this.$restaurant.model.categories
                        .reduce((p, c) => [...p, ...c.meals], [])
                        .find((meal) => meal.id === recommendation.id) || {}),
                    ...{ recommender: this.recommender },
                }
            })
        },
    },
    methods: {
        openMealSelector(model) {
            EventBus.$emit('openMeal', model)
        },
        selectMeal(model) {
            EventBus.$emit('selectMeal', model)
        },
    },
}
